<template>
    <div class="blue-gradient testimonial">
        <div>
            <h2 class="color-white text-center">   {{ $t('testimonials.title') }}</h2>
        </div>
        <div class="testimonial_wrapper">
            <div class="testimonial_inner">
                <!--<div class="testimonial_prev icon-button-lg bg-white color-blue">
                    <b-icon-chevron-left />
                </div>-->


                <div class="testimonial_text color-white">
                    <div v-for="(item, index) in testimonials" :key="index" :class="{'text-active': current === index}">
                        <p v-html="$t(i18nTestimonial(item.id))"></p>
                    </div>
                </div>
                <!--<div class="testimonial_next">
                    <b-icon-chevron-right />
                </div>-->

                <div class="testimonial_menu">

                    <div v-for="(item, index) in testimonials" :key="index" :class="[{'testimonial_writer--active': current === index}, 'testimonial_writer']" @click="current = index;">
                        <div class="testimonial_writer-photo">
                            <img :src="'/images/' + item.photo" />

                        </div>
                        <div class="testominal_writer-details">
                            <div>
                                {{item.name}}
                                <img class="testimonial_writer-flag" :src="'/images/flags/' + item.flag" />
                            </div>
                            <div class="testimonial_writer-sub-text">{{$t(i18nFunctionTitle(item.id))}}</div>
                            <div class="testimonial_writer-sub-text">{{item.hospital}}</div>
                        </div>
                    </div>

                </div>
            </div>
        </div>
    </div>
</template>

<script>

    export default {


        name: 'Testimonial',
        data: function () {

            return {
                current: 0,
                testimonials: [
                    {
                        name: 'Nadine Linthout',
                        hospital: 'OLV Ziekenhuis',
                        photo: 'PhotoOfWriter.jpg',
                        flag: 'flag_be.svg',
                        id: 0
                    },
                    {
                        name: 'Ricardo Hop',
                        hospital: 'Albert Schweitzer Ziekenhuis',
                        flag: 'flag_nl.svg',
                        photo: 'PhotoOfWriter2.jpg',
                        id: 1
                    },
                ]

            }

        },
        components: {

        },
        props: {

        },
        beforeMount: function () {

        },
        mounted: function () {

        },
        methods: {
			i18nTestimonial: function (index) {
				return 'testimonials.testimonial' + index
            },
			i18nFunctionTitle: function (index) {
				return 'testimonials.functionTitle' + index
			},
        },
        computed: {

        },
        watch: {

        }
    }
</script>